import {Response} from 'miragejs';
import IRegistrationRequest from '../../features/registration/models/registration-request-interface';
import RegistrationStatuses from '../../features/registration/models/registration-statuses-enum';
import { cache } from './status-check-router';


const createSuccessResponse = (correlationId: string): Response =>{
  // please note that for testing purposes, we should clear the correlation ID cache. otherwise tester on the demo website
  // will need to refresh the page
  cache.correlationIds={};

  return new Response(200, {}, {
    data: {
      registerDigitalIdentityPublic: {
        correlationId,
        requestAccepted: true,
        notAcceptedReason: null,
        errorKey: null
      }
    }
  });
};


export default function createUserRouter(schema: any, request: any) {
  const body: IRegistrationRequest = JSON.parse(request.requestBody).variables.input;

  switch (body.firstName) {
  case 'field-missing':
    return new Response(200, {}, {errors: [{message: 'FIELD_REQUIRED'}]});
  case 'body-error':
    return new Response(200, {}, {
      data: {
        registerDigitalIdentityPublic: {
          correlationId: '',
          requestAccepted: false,
          notAcceptedReason: 'Invalid request body',
          errorKey: 'INVALID_PARAMETER'
        }
      }
    });
  case 'validation-failed':
    return createSuccessResponse(RegistrationStatuses.ValidationFailed);
  case 'identity-failed':
    return createSuccessResponse(RegistrationStatuses.IdentityCreationFailed);
  case 'duplicate-account':
    return createSuccessResponse(RegistrationStatuses.IdentityCreationFailedDuplicate);
  case 'rollback-completed':
    return createSuccessResponse(RegistrationStatuses.RollbackCompleted);
  default:
    return createSuccessResponse(RegistrationStatuses.Completed);
  }

}
